import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Actions from './Actions';

const StyledSeparator = styled('hr')(({ theme, separatorColor }) => ({
  border: 'none',
  borderTop: `1px solid ${separatorColor || '#ccc'}`,
  margin: '16px 24px 0 24px',
  width: 'calc(100% - 48px)',
}));

const DialogActions = ({ 
  handleClose, 
  handleSave, 
  separatorColor,
  showSeparator = true,
  ...props 
}) => {
  const actionProps = { handleClose, handleSave, ...props };

  return (
    <Box>
      {showSeparator && <StyledSeparator separatorColor={separatorColor} />}
      <Actions {...actionProps} />
    </Box>
  );
};

export default DialogActions;
